const availableFilters = [
	{ label: 'Category', key: 'Category__c', type: 'list', values: ["Innovation", "POC (Innovation)", "Marketing", "Opportunity Acceleration", "Migration", "Marketplace Concessions"]},
	{ label: 'Priority', key: 'Priority__c', type: 'list', values: ["Low", "Medium", "High"]},
	{ label: 'Type', key: 'Type__c', type: 'list', values: ["Cash", "Credit"]},
	{ label: 'Leading Cloud', key: 'Leading_Cloud__c', type: 'list', values: ["AWS", "MS", "GCP"]},
	{ label: 'Amount', key: 'Amount__c', type: 'numeric'},
	{ label: 'Status', key: 'Status__c', type: 'list', values: ["Planned", "Application Ready", "Applied", "Under Review", "Approved", "Declined", "Received", "Abandoned" ]}
];

export default availableFilters;
